import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import BlogPost from '../blog-post';

import { BlogPostData } from '../types';

type BlogPostsProps = {
  posts: BlogPostData[];
};

const BlogPosts: LitheFC<BlogPostsProps> = ({
  id = 'blog-posts',
  testId = 'blog-posts',
  posts,
}): LitheElement<'ul'> => [
  'ul',
  { id, 'data-testid': testId, class: 'list-none mt-4 p-0 col-span-12' },
  ...posts.map<LitheElement<'li'>>((post) => BlogPost(post)),
];

export default BlogPosts;
